import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {get_purchases, get_purchases_request} from '../../redux/actions/user';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import PurchaseRequest from "../../components/dashboard/purchase/purchaseRequest";
import PurchasesAccept from "../../components/dashboard/purchase/PurchasesAccept";

const Purchases = ({get_purchases_request}) => {
    useEffect(() => {
        get_purchases_request();
    }, []);


    return (
      <div>
          <PurchasesAccept/>
      </div>
    );
};

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, { get_purchases_request })(Purchases);
